import { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import ScrollToTop from '@/shared/components/ScrollToTop';
import AddAccountingEntry from '@/views/AddAccountingEntry/AddAccountingEntry';

const NotFoundPage = lazy(() => import('@/views/NotFound/NotFoundPage'));
const HomePage = lazy(() => import('@/views/Home/HomePage'));

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p></p>
      </div>}>
        <Routes>
          {/* <Route element={<ProtectedRoute />}> */}
          <Route path="/" element={<HomePage />} />
          <Route path="/add_accounting_entry" element={<AddAccountingEntry />} />


          {/* </Route> */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};
